import types from "./types";

const initialState = {
  showLoginModal: false,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_LOGIN_MODAL:
      return { ...state, showLoginModal: true };

    case types.HIDE_LOGIN_MODAL:
      return { ...state, showLoginModal: false };

    default:
      return state;
  }
};

export default appReducer;
